import { render, staticRenderFns } from "./CreateAvatar.vue?vue&type=template&id=12873a7a&scoped=true"
import script from "./CreateAvatar.vue?vue&type=script&lang=js"
export * from "./CreateAvatar.vue?vue&type=script&lang=js"
import style0 from "./CreateAvatar.vue?vue&type=style&index=0&id=12873a7a&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12873a7a",
  null
  
)

export default component.exports